import React, { SVGProps } from 'react';

export const IconUser = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="M16 16a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 2.5c-3.34 0-10 1.68-10 5v2c0 .28.22.5.5.5h19a.5.5 0 0 0 .5-.5v-2c0-3.32-6.66-5-10-5Z"/></svg>;
